function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import { element, widget } from '@wix/editor';
import { createClient } from '@wix/sdk';
var _PlatformDevTools_brand = /*#__PURE__*/new WeakSet();
export class PlatformDevTools {
  constructor(infra, manifestsManager) {
    this.infra = infra;
    this.manifestsManager = manifestsManager;
    _classPrivateMethodInitSpec(this, _PlatformDevTools_brand);
  }
  register() {
    if (typeof window === 'undefined' || globalThis.$sdk) {
      return;
    }
    globalThis.$sdk = _assertClassBrand(_PlatformDevTools_brand, this, _exposeSDKDevTools).call(this);
  }
}
function _exposeSDKDevTools() {
  return {
    element: editorPointer => {
      const host = this.infra.getSDKHost({
        contextBuilder: builder => {
          builder.withRuntimeMappings(false);
          builder.byEditorPointer(editorPointer, editorElement => {
            builder.withEditorElement(editorPointer, editorElement);
          });
        }
      });
      return createClient({
        host,
        modules: {
          element
        }
      }).element;
    },
    widget: () => {
      const host = this.infra.getSDKHost({
        contextBuilder: () => {}
      });
      return createClient({
        host,
        modules: {
          widget
        }
      }).widget;
    },
    getComponentsService: () => {
      return this.manifestsManager.getComponentsService().getPublicManifestAPI();
    },
    getManifest: editorPointer => {
      return this.manifestsManager.getManifestByEditorPointer(editorPointer);
    },
    getBuilderManifests: () => {
      return this.manifestsManager.getBuilderManifests();
    },
    getBuilderPanels: () => {
      return this.manifestsManager.getBuilderPanels();
    },
    getSDKRuntimeContexts: () => {
      return this.manifestsManager.getSDKRuntimeContexts();
    }
  };
}
//# sourceMappingURL=PlatformDevTools.js.map